import { LoadingSpinner } from '@domgen/base-design-system-2.0/atoms/LoadingSpinner';
import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { useTranslation } from 'react-i18next';
import { useIsTenantFeatureEnabled } from '../hooks';

export const LoadingPage = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'loader',
  });

  const phoneNumber = t('phoneNumber');

  const isPhoneNumberDisplayed = useIsTenantFeatureEnabled('loadingPhoneUs');

  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-neutral-100 text-neutral-900 flex flex-col justify-center items-center z-50">
      <div className="w-12 h-12">
        <LoadingSpinner />
      </div>

      <h3 className="text-heading-3 mt-4 mb-2">{t('header')}</h3>
      <p className="px-14 text-center text-body md:max-w-[465px]">
        {t('text')}
        {isPhoneNumberDisplayed && (
          <span className="inline">
            <TextLink href={`tel:${phoneNumber.replace(/[^\d+]/g, '')}`}>{phoneNumber}</TextLink>
          </span>
        )}
      </p>
    </div>
  );
};
